import React, { useState } from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useCurrentApplication } from "../../../Context/CurrentApplicationContext/CurrentApplicationContext";
import { WhatsAppConsent } from "../../../Interface/Index";
import ProfileMatcherService from "../../../Services/profile.matcher.service";
import { openNotification } from "../../../Components/Notification/Index";

const WhatsAppConsentCard: React.FC = () => {
  const { userProfile, setUserProfile } = useCurrentApplication();
  const [loading, setLoading] = useState(false);

  if (!userProfile) {
    return null;
  }

  const whatsAppConsent = userProfile.basicDetails?.whatsAppConsent;
  const hasConsent = whatsAppConsent !== undefined && whatsAppConsent !== null;
  const consentValue = whatsAppConsent?.consent;

  const toggleConsent = async () => {
    if (!hasConsent || loading) return;
    setLoading(true);
    try {
      const newValue = !consentValue;
      const updatedConsent: WhatsAppConsent = {
        consent: newValue,
        timestamp: new Date(),
        history: [
          ...(whatsAppConsent?.history || []),
          { consent: newValue, timestamp: new Date() },
        ],
      };
      const result = await new ProfileMatcherService().updateUserProfile(
        userProfile._id,
        {
          basicDetails: {
            ...userProfile.basicDetails,
            whatsAppConsent: updatedConsent,
          },
        },
      );
      if (result.success && result.data) {
        setUserProfile(result.data);
        openNotification(
          "success",
          "Updated",
          "WhatsApp notification preference updated.",
        );
      } else {
        openNotification(
          "error",
          "Error",
          "Cannot update WhatsApp notification preference.",
        );
      }
    } catch (error) {
      console.error("Unable to update WhatsApp consent", error);
      openNotification("error", "Error", "Unable to update WhatsApp consent.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="job-posts-details__sidebar-process-card job-posts-details__sidebar-whatsapp-card">
      <h4 className="job-posts-details__sidebar-process-title">
        WhatsApp Notifications
      </h4>
      {!hasConsent ? (
        <p className="job-posts-details__sidebar-whatsapp-support-text">
          Please contact the support team to turn on notifications.
        </p>
      ) : (
        <button
          className={`job-posts-details__sidebar-whatsapp-toggle${loading ? " job-posts-details__sidebar-whatsapp-toggle--loading" : ""}`}
          onClick={toggleConsent}
          disabled={loading}
          title={
            consentValue
              ? "Click to unsubscribe notifications"
              : "Click to subscribe notifications"
          }
        >
          <img
            src="/icons/whatsapp.svg"
            alt="WhatsApp"
            className="job-posts-details__sidebar-whatsapp-icon"
          />
          <span className="job-posts-details__sidebar-whatsapp-label">
            Notifications
          </span>
          {consentValue ? (
            <CheckCircleOutlined className="job-posts-details__sidebar-whatsapp-status job-posts-details__sidebar-whatsapp-status--on" />
          ) : (
            <CloseCircleOutlined className="job-posts-details__sidebar-whatsapp-status job-posts-details__sidebar-whatsapp-status--off" />
          )}
        </button>
      )}
    </div>
  );
};

export default WhatsAppConsentCard;
